import Ventana from "../../../isp._comun/iu/_principal/reductores/Ventana";
// import { ModosOp} from "../../../isp._comun/iu/_principal/constantesIuPrin";
import { DialogType, ModosOp} from "../../../isp._comun/iu/_principal/constantesIuPrin";
import getEstadoInicial from "../EstadoDialogoCliente";

export default class VentanaCliente extends Ventana {
    constructor(estadoComp) {
        super();
        this.id= DialogType.CLIENTE+estadoComp.domain.screen.idCliente;
        // this.id= VentanaCliente.name+estadoComp.domain.screen.idCliente;
        this.estadoComp = estadoComp;
        // this.id= estadoComp.flag.modoOperacion+estadoComp.domain.screen.idCliente;
        // this.id= this.estadoComp.flag.modoOperacion+this.estadoComp.domain.screen.idCliente;
        /* this.estadoCom = {
            domain: {
                screen: {
                    idCliente: null,
                },
            },
            flag: {
                modoOperacion: ModosOp.CREAR,
                modal: false,
                cargandoEntidad: false,
            },
        }; */
        // this.dispatch = null;
        // this.ventanaCargando=null
    }

    static nuevaVentanaEnModoCrear() {
        const estadoComp = getEstadoInicial();
        return new VentanaCliente(estadoComp);
    }

    static nuevaVentanaEnModoOk(idCliente) {
        const estadoComp = getEstadoInicial();
        estadoComp.flag.modoOperacion = ModosOp.OK;
        estadoComp.domain.screen.idCliente = idCliente;
        estadoComp.flag.modal = true;
        estadoComp.flag.cargandoEntidad = true;
        estadoComp.flag.tipoClienteSelec = false;
        return new VentanaCliente(estadoComp);
    }

    puedeHacersePasarPor(ventanaAAbrir) {
        if (!(ventanaAAbrir instanceof VentanaCliente)) {
            return false;
        }

        if(this.id === ventanaAAbrir.id){
            return true;
        }

        /* if (
            this.estadoComp.flag.modoOperacion === ModosOp.CREAR &&
            ventanaAAbrir.estadoComp.flag.modoOperacion === ModosOp.CREAR
        ) {
            return true;
        }

        if (
            this.estadoComp.flag.modoOperacion !== ModosOp.CREAR &&
            ventanaAAbrir.estadoComp.flag.modoOperacion !== ModosOp.CREAR &&
            this.estadoComp.domain.screen.idCliente ===
                ventanaAAbrir.estadoComp.domain.screen.idCliente
        ) {
            return true;
        } */

        return false;
    }

    clonar() {
        const nuevaVentana = new VentanaCliente(this.estadoComp);
        nuevaVentana.posicionZ = this.posicionZ;
        // nuevaVentana.id = this.id;
        // nuevaVentana.estadoComp = this.estadoComp;
        // nuevaVentana.dispatch = this.dispatch;
        // nuevaVentana.ventanaCargando = this.ventanaCargando
        return nuevaVentana;
    }

    getReactElement() {
        
    }
}
